import { useState } from 'react';

export const usePaymentPlan = (getCartTotal) => {
  const [checkoutPaymentPeriod, setCheckoutPaymentPeriod] = useState('day1');
  const [installmentFrequency, setInstallmentFrequency] = useState('monthly');
  const [installmentOverride, setInstallmentOverride] = useState('');
  const [numberOfInstallments, setNumberOfInstallments] = useState('1');
  const [customPeriodDays, setCustomPeriodDays] = useState('30');

  const getSelectedPaymentPeriod = (giftItems) => {
    const giftItemsWithPeriod = giftItems.filter(item => item.isGift && item.paymentPeriod);
    if (giftItemsWithPeriod.length > 0) {
      return giftItemsWithPeriod[0].paymentPeriod;
    }
    return null;
  };

  const getPaymentPlanDetails = (paymentPeriod, overrideAmount = null) => {
    const today = new Date();
    const calculateFutureDate = (daysFromNow) => {
      const futureDate = new Date(today);
      futureDate.setDate(today.getDate() + daysFromNow);
      return futureDate.toISOString().slice(0, 10);
    };
    
    const cartTotal = getCartTotal();
    
    const plans = {
      'day1': { 
        label: 'Pay full within 2 days',
        ins_frequency: 'one-time',
        ins_amount: null,
        max_no_of_ins: '0',
        final_ins_date: null
      },
      'day30': { 
        label: 'Pay full by end of the month',
        ins_frequency: 'monthly',
        ins_amount: overrideAmount || cartTotal.toFixed(0),
        max_no_of_ins: '1',
        final_ins_date: calculateFutureDate(30)
      },
      'day60': { 
        label: 'Pay full within 2 months',
        ins_frequency: 'monthly',
        ins_amount: overrideAmount || Math.round(cartTotal / 2).toFixed(0),
        max_no_of_ins: '2',
        final_ins_date: calculateFutureDate(60)
      },
      'day90': { 
        label: 'Pay full within 3 months',
        ins_frequency: 'monthly',
        ins_amount: overrideAmount || Math.round(cartTotal / 3).toFixed(0),
        max_no_of_ins: '3',
        final_ins_date: calculateFutureDate(90)
      },
      'day180': { 
        label: 'Pay full within 6 months',
        ins_frequency: 'monthly',
        ins_amount: overrideAmount || Math.round(cartTotal / 6).toFixed(0),
        max_no_of_ins: '6',
        final_ins_date: calculateFutureDate(180)
      }
    };
    
    return plans[paymentPeriod] || plans['day1'];
  };

  return {
    checkoutPaymentPeriod,
    installmentFrequency,
    installmentOverride,
    numberOfInstallments,
    customPeriodDays,
    setCheckoutPaymentPeriod,
    setInstallmentFrequency,
    setInstallmentOverride,
    setNumberOfInstallments,
    setCustomPeriodDays,
    getSelectedPaymentPeriod,
    getPaymentPlanDetails
  };
};
